import { useInfiniteScroll, useRequest } from 'ahooks';
import { useState } from 'react';
import {
  queryCateGoryService,
  queryFaqService,
  querySubjectService,
} from './services';

export default function FAQMgrModel() {
  const [queryValue, setQueryValue] = useState<any>({});

  const {
    data = { list: [] },
    loading,
    loadingMore,
    loadMore,
    noMore,
  } = useInfiniteScroll(
    (d) =>
      queryFaqService({
        ...queryValue,
        pageIndex: d?.pageIndex || 0,
        pageCount: 6,
        status: 'A',
      }),
    {
      isNoMore: (d) => !(d && d.list.length >= d.pageCount * d.pageIndex),
      manual: true,
      reloadDeps: [queryValue],
    },
  );

  const { data: catalogData = [], run: queryCateGoryList } = useRequest(
    queryCateGoryService,
    {
      manual: true,
    },
  );

  const { data: subjectData = [], run: querySubjectList } = useRequest(
    querySubjectService,
    {
      manual: true,
    },
  );

  //   const addCategory = async (data: any) => {
  //     await addCategoryService(data);
  //     reload();
  //   };

  // useEffect(() => {
  //   if (data.list?.length) {
  //     setSelectedCategory(data.list[0].faqCatgId);
  //   } else {
  //     setSelectedCategory(null);
  //   }
  // }, [data.list]);

  return {
    questionList: data.list,
    loading,
    loadingMore,
    loadMore,
    noMore,
    // queryQuestions,
    queryValue,
    setQueryValue,
    cateGoryList: catalogData,
    queryCateGoryList,
    subjectList: subjectData,
    querySubjectList,
  };
}
